import { useSnapshot } from 'valtio'
import styled from 'styled-components'
import { state } from '../../context/store'
import { Grid } from '../Blocks/index'
import '../../assets/styles/fonts.css'

const FontLabel = ({ label, font, size, target, sizeTarget }) => {
  const snap = useSnapshot(state.current.choices.superBadge.selected)
  const selected = font === snap[target]

  return (
    <FontLabelText
      $font={font}
      $selected={selected}
      $size={size}
      onClick={() => {
        state.current.choices.superBadge.selected[target] = font
        state.current.choices.superBadge.selected[sizeTarget] = size
      }}
    >
      {label}
    </FontLabelText>
  )
}

const FontSelector = ({ target = 'font', sizeTarget = 'riderNameSize' }) => {
  const snap = useSnapshot(state.current)

  return (
    <Grid cols="1fr 1fr" mCols="1fr 1fr">
      {snap.fonts.map((font) => (
        <FontLabel
          key={font.filename}
          label={font.visiblename}
          size={font.size}
          font={font.family}
          target={target}
          sizeTarget={sizeTarget}
        />
      ))}
    </Grid>
  )
}

export default FontSelector

const FontLabelText = styled.div`
  font-family: ${(props) => props.$font};
  color: black;
  text-align: center;
  vertical-align: baseline;
  line-height: 1;
  border: ${(props) => (props.$selected ? '3px solid lime' : '3px solid transparent')};
  background: white;
  border-radius: 8px;
  cursor: pointer;
  margin-block: 0;
  font-size: ${(props) =>
    props.$size === 'small'
      ? '21px'
      : props.$size === 'medium'
        ? '17px'
        : '13px'};
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`